import React, { Component } from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,

} from "react-router-dom";

import ProtectedRoute from './ProtectedRoute';
import LoginScreen from '../components/auth/LoginScreen';
import ErrorPermiso from '../components/errors/ErrorPermiso';
import Carrera from '../components/iniciales/Carrera';
import CarrerasScreen from '../components/iniciales/CarrerasScreen';
import RutasAdministrativo from './RutasAdministrativo';
import RutasSecretaria from './RutasSecretaria';
import RutasColecturia from './RutasColecturia';
import RutasVicerrectoradoAdm from './RutasVicerrectoradoAdm';
import RutasEstudiante from './RutasEstudiante';
import RutasBienestar from './RutasBienestar';
import RutasDocente from './RutasDocente';
import RutasCoordinacionAcad from './RutasCoordinacionAcad';
import RutasVicerrectoradoAcad from './RutasVicerrectoradoAcad';
import RutasUComunicacion from './RutasUComunicacion';
import RutasRecepcion from './RutasRecepcion';
import RutasAtencionPacientes from './RutasAtencionPacientes';
import RutasDirectorPracticas from './RutasDirectorPracticas';
import RutasPlanificacion from './RutasPlanificacion';
import RutasEvaluacion from './RutasEvaluacion';
import RutasACalidad from './RutasACalidad';
import RutasRectorado from './RutasRectorado';
import RutasGestorPlataforma from './RutasGestorPlataforma';
import RutasDirectorTitulacion from './RutasDirectorTitulacion';
import RutasBiblioteca from './RutasBiblioteca';

export default class RoutesApp extends Component {
    render() {

        return (
            <div>

                <Router>
                    <Switch>
                        {/* Rutas públicas */}
                        <Route exact path="/" component={CarrerasScreen} />
                        <Route exact path="/carrera" component={Carrera} />
                        <Route exact path="/login" component={LoginScreen} />
                        <Route path="/errorpermiso" component={ErrorPermiso} />

                        {/* Rutas protegidas */}
                        <ProtectedRoute
                            path="/estudiante"
                            component={RutasEstudiante}
                            allowedRoles={['0']}
                        />
                        <ProtectedRoute
                            path="/administrativo"
                            component={RutasAdministrativo}
                            allowedRoles={['1']}
                        />
                        <ProtectedRoute
                            path="/docente"
                            component={RutasDocente}
                            allowedRoles={['2']}
                        />
                        <ProtectedRoute
                            path="/colecturia"
                            component={RutasColecturia}
                            allowedRoles={['3']}
                        />
                        <ProtectedRoute
                            path="/secretaria"
                            component={RutasSecretaria}
                            allowedRoles={['4']}
                        />
                        <ProtectedRoute
                            path="/vicerrectoradoadm"
                            component={RutasVicerrectoradoAdm}
                            allowedRoles={['5']}
                        />
                        <ProtectedRoute
                            path="/bienestar"
                            component={RutasBienestar}
                            allowedRoles={['6']}
                        />
                        <ProtectedRoute
                            path="/coordinacionacad"
                            component={RutasCoordinacionAcad}
                            allowedRoles={['7']}
                        />
                        <ProtectedRoute
                            path="/ucomunicacion"
                            component={RutasUComunicacion}
                            allowedRoles={['8']}
                        />
                        <ProtectedRoute
                            path="/recepcion"
                            component={RutasRecepcion}
                            allowedRoles={['9']}
                        />
                        <ProtectedRoute
                            path="/vicerrectoradoacad"
                            component={RutasVicerrectoradoAcad}
                            allowedRoles={['10']}
                        />
                        <ProtectedRoute
                            path="/atencionpacientes"
                            component={RutasAtencionPacientes}
                            allowedRoles={['11']}
                        />
                        <ProtectedRoute
                            path="/planificacion"
                            component={RutasPlanificacion}
                            allowedRoles={['12']}
                        />
                        <ProtectedRoute
                            path="/directorpracticas"
                            component={RutasDirectorPracticas}
                            allowedRoles={['13']}
                        />
                        <ProtectedRoute
                            path="/evaluacion"
                            component={RutasEvaluacion}
                            allowedRoles={['14']}
                        />
                        <ProtectedRoute
                            path="/acalidad"
                            component={RutasACalidad}
                            allowedRoles={['15']}
                        />
                        <ProtectedRoute
                            path="/rectorado"
                            component={RutasRectorado}
                            allowedRoles={['16']}
                        />
                        <ProtectedRoute
                            path="/gestorplataforma"
                            component={RutasGestorPlataforma}
                            allowedRoles={['17']}
                        />
                        <ProtectedRoute
                            path="/directortitulacion"
                            component={RutasDirectorTitulacion}
                            allowedRoles={['18']}
                        />
                        <ProtectedRoute
                            path="/biblioteca"
                            component={RutasBiblioteca}
                            allowedRoles={['19']}
                        />

                        {/* Si ninguna coincide, redirige a inicio */}
                        <Redirect to="/" />
                    </Switch>
                </Router>

            </div>
        )
    }
}